// Petites animations du site : le panier rebondit quand son contenu change.
(() => {
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  const watchCart = () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || bubble.dataset.jgWatched) return;
    bubble.dataset.jgWatched = 'true';
    const bump = () => {
      if (calm.matches) return;
      bubble.classList.remove('jg-cart-bump');
      void bubble.offsetWidth;
      bubble.classList.add('jg-cart-bump');
    };
    bubble.addEventListener('animationend', () => bubble.classList.remove('jg-cart-bump'));
    new MutationObserver(bump).observe(bubble, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart, { once: true });
  else watchCart();
  document.addEventListener('shopify:section:load', watchCart);
})();
